import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import AddIcon from "@material-ui/icons/Add";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { FieldArray } from "formik";
import React, { useState } from "react";
import styled from "styled-components";
import SelectModal from "../../concur/SelectModal";

const fields = [
	{
		name: "TP_DOC",
		label: "Tipo Documento",
		type: "text",
	},
	{
		name: "SP_GL_INDN",
		label: "SP_GL_INDN",
		type: "text",
	},
		{
		name: "PMNTTRMS",
		label: "PMNTTRMS",
		type: "text",
	},
	{
		name: "operation",
		label: "Tipo de operação",
		type: "select",
		options: [
			{
				value: "prestacaoconta",
				label: "Prestacao de Conta",
			},
			{ value: "adiantamento", label: "Adiantamento" },
		],
	},
];

function TabFieldsConfigurantion({
	values,
	errors,
	handleChange,
	touched,
	initialValues,
	setFieldValue,
}) {
	const viceri = values.ecc ? values.ecc : [];

	const [select, setSelecting] = useState({
		name: null,
		label: null,
		options: [],
	});

	return (
		<>
			{select && !!select.name && (
				<SelectModal
					title={"Selecionar"}
					items={select.options}
					selected={null}
					onSelect={(item) => {
						setFieldValue(`ecc[${select.index}].${select.name}`, item.value);
						setSelecting(null);
					}}
					onClose={() => {
						setSelecting(null);
					}}
					show={!!select.name}
				/>
			)}
			<FieldArray name="ecc">
				{({ push, remove }) => (
					<ContainerGrid>
						{viceri.map((_, index) => {
							return (
								<GridRow key={index}>
									{fields.map((field) => {
										if (field.type === "select") {
											return (
												<>
													<TextField
														id={`empresa[${index}].${field.name}-label`}
														value={values.ecc[index][field.name]}
														label={field.label}
														onClick={() => {
															setSelecting({ ...field, index });
														}}
													/>
												</>
											);
										} else {
											return (
												<ContainerField key={`${index}-${field.name}`}>
													<TextField
														fullWidth
														InputLabelProps={{ shrink: true }}
														name={`ecc[${index}].${field.name}`}
														label={field.label}
														value={values.ecc[index][field.name]}
														onChange={handleChange}
														error={
															touched &&
															touched.ecc &&
															touched.ecc[index] &&
															touched.ecc[index][field.name] &&
															Boolean(
																errors &&
																	errors.ecc &&
																	errors.ecc[index] &&
																	errors.ecc[index][field.name]
															)
														}
														helperText={
															touched &&
															touched.ecc &&
															touched.ecc[index] &&
															touched.ecc[index][field.name] &&
															errors &&
															errors.ecc &&
															errors.ecc[index] &&
															errors.ecc[index][field.name]
														}
														autoComplete="off"
														type={field.type}
													/>
												</ContainerField>
											);
										}
									})}

									<Button onClick={() => remove(index)} color="secondary">
										<HighlightOffIcon />
									</Button>
								</GridRow>
							);
						})}
						<ContainerButtons>
							<Button
								variant="contained"
								color="primary"
								onClick={() => push(initialValues)}
							>
								<AddIcon />
							</Button>
						</ContainerButtons>
					</ContainerGrid>
				)}
			</FieldArray>
		</>
	);
}

export default TabFieldsConfigurantion;

const ContainerGrid = styled.div`
	display: flex;
	flex-direction: column;
`;
const GridRow = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
	padding: 0px 5px 5px 0px;
`;

const ContainerButtons = styled.div`
	display: flex;
	flex-direction: row;
	margin-top: 20px;
	margin-bottom: 20px;
`;

const ContainerField = styled.div`
	margin-right: 2px;
`;
